/* eslint-disable no-inner-declarations */
/* eslint-disable no-empty */
/**
 * External Dependencies
 */
import 'jquery';
import 'alpinejs';
import Swiper from 'swiper/bundle';
import MicroModal from 'micromodal';
MicroModal.init({});

/*******DT DEVELOP********/
// Swiper 
(function () {
  // Home page scrollbar products slider
  var swiperHomeProducts = new Swiper('.swiper-product-scrollbar', {
    slidesPerView: 2.5,
    spaceBetween: 10,
    scrollbar: {
      el: '.swiper-scrollbar',
    },
    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  });
  // Home page gallery Social wall slider
  var swiperHomeProducts = new Swiper('.swiper-social-wall', {
    slidesPerView: 2.5,
    spaceBetween: 10,
    loop: true,
    breakpoints: {
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 13,
        centeredSlides: true,
      },
      1500: {
        slidesPerView: 4.5,
        spaceBetween: 13,
        centeredSlides: true,
      },

    },
  });
  // Product page gallery
  var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 3,
    loopedSlides: 5, //looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.thumbs',
      prevEl: '.swiper-button-prev.thumbs',
    },
  });
  var galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    loopedSlides: 5, //looped slides should be the same
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });
  // Product page gallery Mobile
  var galleryMobile = new Swiper('.swiper-gallery-mobile', {
    pagination: {
      el: '.swiper-pagination',
    },
  });
  // Product page related product
  var swiperRelated = new Swiper('.swiper-related', {
    slidesPerView: 2.5,
    spaceBetween: 10,
    loop: true,
  });
  // Product page Reviews
  var swiperReviews = new Swiper('.swiper-reviews', {
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  var swiperReviewsMobile = new Swiper('.swiper-reviews-mobile', {
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      type: 'fraction',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

})();

jQuery(document).ready(function () {

  //// GENERAL
  // Timer cookie
  let countdownSeconds = 1700;
  let currentTime = localStorage.getItem('uuCountdownTimer');
  if (currentTime !== null) {
    console.log(currentTime);
    console.log(getSecondsFromTime(currentTime));
    countdownSeconds = getSecondsFromTime(currentTime);
  }
  let timer = new easytimer.Timer();
  timer.start({ countdown: true, startValues: { seconds: countdownSeconds } });
  jQuery('.timer-cookie').html(timer.getTimeValues().minutes + ':' + timer.getTimeValues().seconds);
  timer.addEventListener('secondsUpdated', function (e) {
    localStorage.setItem('uuCountdownTimer', timer.getTimeValues().toString());
    jQuery('.timer-cookie').html(localStorage.getItem('uuCountdownTimer').split(':').slice(1).join(':'));
  });
  timer.addEventListener('targetAchieved', function (e) {
    jQuery('.timer-cookie').html('0:00');
  });
  function getSecondsFromTime(time) {
    let a = time.split(':');
    let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
    return seconds;
  }



  //// SHOP PAGE
  if (jQuery("body").hasClass("archive")) {

    // SORT by modal  - custom order by
    jQuery(".modal__content label").on("click", function () {
      let orderByUrl = jQuery(this).find("input").data("url");
      jQuery(".modal__footer a.button-submit").addClass("active");

      jQuery(".modal__footer a.button-submit").on("click", function () {
        setTimeout(function () {
          window.location.href = "?orderby=" + orderByUrl;
        }, 50);
      });
    });
  }

  //// PRODUCT PAGE
  if (jQuery("body").hasClass("product-template-default")) {


  }

  //// CART AND CHECKOUT PAGE
  if (jQuery("body").hasClass("woocommerce-cart") || jQuery("body").hasClass("woocommerce-checkout")) {

    // Update cart - uu 
    let timeout;
    let timeoutMs = 1;

    jQuery("div.woocommerce").on("change keyup mouseup", "input.qty", function () { // keyup and mouseup for Firefox support
      if (timeout != undefined) {
        clearTimeout(timeout)
      }; //cancel previously scheduled event
      if (jQuery(this).val() == "") return; //qty empty, instead of removing item from cart, do nothing
      timeout = setTimeout(function () {
        jQuery("[name=\"update_cart\"]").trigger("click");
      }, timeoutMs); // schedule update cart event with delay in miliseconds
    });

    // Custom select qty on checkout
    function dtquantity() {
      jQuery(".product-quantity").each(function () {
        let currentQty = jQuery(this).find(".qty").val();
        jQuery(this).find("#custom-qty").val(currentQty);
      });

      jQuery(".product-quantity #custom-qty").change(function () {
        let currentQtyCustom = jQuery(this).val();
        jQuery(this).closest(".product-quantity").find(".quantity .qty").val(currentQtyCustom);

        setTimeout(function () {
          jQuery("[name=\"update_cart\"]").trigger("click");
        }, 10);
      });
    }

    dtquantity();

    jQuery(document.body).on('updated_cart_totals', function () {
      dtquantity();
    });

    jQuery(document).ajaxComplete(function () {
      dtquantity();

    });



  }

  //// CHECKOUT PAGE
  if (jQuery("body").hasClass("woocommerce-checkout")) {

    // Add text below phone field
    jQuery("#billing_email").after("<div class='email-info'>" + uu.email + "</div>")

    // Floating labels
    function setFloatingFields(element) {
      let formLabels = jQuery("label[for=" + jQuery(element).attr('id') + "]");
      if (jQuery(element).val().length > 0) {
        formLabels.addClass('floating-label');
      } else {
        formLabels.removeClass('floating-label');
      }
    }

    jQuery('.form-row input, .form-row textarea').each(function () {
      setFloatingFields(this);
    });
    jQuery('.form-row input, .form-row textarea').on('change keyup', function () {
      setFloatingFields(this);
    });

    // TOOLTIP ADDRESS
    jQuery("#billing_address_1_field").addClass("tooltip");
    jQuery("#tooltip-address").detach().appendTo("#billing_address_1_field");

    jQuery("#billing_address_1_field").keypress(function () {
      jQuery("#tooltip-address").css("visibility", "visible");
    });
    jQuery("#billing_address_2_field").keypress(function () {
      jQuery("#tooltip-address").css("visibility", "hidden");
    });

    // Custom mobile place order button
    jQuery(".custom-place-order").on('click', function () {
      jQuery("#place_order").trigger('click');
    });


  }

  //// CHECKOUT PAGE WITHOUT THANK YOU PAGE
  if (jQuery("body").hasClass("woocommerce-checkout") && !jQuery("body").hasClass("woocommerce-order-received")) {
    // PHONE FLAG FIELD - COUNTRYCODE
    setTimeout(function () {
      let countrycode = jQuery(".selected-flag").attr("title").replace(/[^\d]/g, '');

      jQuery(".selected-flag").append("<div class='country-code'></div>");

      jQuery(".selected-flag .country-code").text("+" + countrycode);
    }, 800);


    jQuery("#billing_country").change(function () {
      setTimeout(function () {
        let countrycode2 = jQuery(".selected-flag").attr("title").replace(/[^\d]/g, '');
        jQuery(".selected-flag .country-code").text("+" + countrycode2);
      }, 800);
    });

    jQuery("li.country").click(function () {
      setTimeout(function () {
        let countrycode2 = jQuery(".selected-flag").attr("title").replace(/[^\d]/g, '');
        jQuery(".selected-flag .country-code").text("+" + countrycode2);
      }, 800);
    });
  }

  // Disable scroll to top on woo ajax change
  jQuery(document).ajaxComplete(function () {
    if (jQuery('body').hasClass('woocommerce-checkout')) {
      jQuery('html, body').stop();
    }
    // IF BILLING FIELD INCORRECT SCROLL TO ERROR
    setTimeout(function () {
      if (jQuery('ul').hasClass('woocommerce-error')) {
        jQuery('html, body').animate({
          scrollTop: parseInt(jQuery(".woocommerce-error").offset().top)
        }, 100);
      }
    }, 300);
  });

  if (jQuery('body').hasClass('single-product')) {
    jQuery('.readmore').readmore({
      collapsedHeight: 80,
      moreLink: '<a href="#">' + readmore.more + '</a>',
      lessLink: '<a href="#">' + readmore.less + '</a>',
    });
  }

});